import { TAPICountryDetails } from './country-details.hook';

export const mockedCountryDeatilsResponse: TAPICountryDetails[] = [
  {
    "country_code_iso2": "AD",
    "country_name": "Andorra",
    "isd_code": "376",
    "id": '941058a3-ed78-486c-8b0b-5e3faa4a1a65'
  },
  {
    "country_code_iso2": "AE",
    "country_name": "United Arab Emirates",
    "isd_code": "971",
    "id": '941058a3-ed78-486c-8b0b-5e3faa4a1a66'
  },
  {
    "country_code_iso2": "AF",
    "country_name": "Afghanistan",
    "isd_code": "93",
    "id": '941058a3-ed78-486c-8b0b-5e3faa4a1a67'
  },
];
